import { Input, makeStyles, shorthands } from "@fluentui/react-components";
import React from "react";

const useStyles = makeStyles({
  root: {
    // Stack the label above the field with a gap
    display: "flex",
    flexDirection: "column",
    width: "100%",
    ...shorthands.gap("2px"),
  },
});

type NumberInputFilterProps = {
  filter: {
    type: string;
    column: string;
    label: string;
  };
  onChangeFilter: (column, value) => void;
};

export default function NumberInputFilter({ filter, onChangeFilter }: NumberInputFilterProps) {
  const styles = useStyles();
  const [value, setValue] = React.useState("");

  const onChangeValue = (value) => {
    setValue(value);
    onChangeFilter(filter.column, value);
  };
  return (
    <div className={styles.root}>
      <Input placeholder={`Enter ${filter.label}`} type={"number"} value={value} onChange={(e) => onChangeValue(e.target.value)} />
    </div>
  );
}
